import { render, staticRenderFns } from "./GlobalTag.vue?vue&type=template&id=6ef49eb6&scoped=true&"
import script from "./GlobalTag.vue?vue&type=script&lang=js&"
export * from "./GlobalTag.vue?vue&type=script&lang=js&"
import style0 from "./GlobalTag.vue?vue&type=style&index=0&id=6ef49eb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef49eb6",
  null
  
)

export default component.exports